var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.staff.name))]),_c('div',{staticClass:"small pl-2"},[_vm._v(_vm._s(_vm.staff.tel))]),_c('div',{staticClass:"small pl-2"},[_vm._v(_vm._s(_vm.staff.mail))])])}
var staticRenderFns = []

export { render, staticRenderFns }